import { FC } from 'react';
import { IconType } from 'react-icons/lib';
import { FadeLoader } from 'react-spinners';
import { TotalsInfoCardContainer } from './styles';

interface TotalsInfoCardProps {
  icon: React.ReactElement<IconType>;
  titleCard: string;
  percentFooter: string;
  textFooter: string;
  totalValue: string;
  isLoading: boolean;
}

const TotalsInfoCard: FC<TotalsInfoCardProps> = ({
  icon,
  titleCard,
  totalValue,
  percentFooter,
  textFooter,
  isLoading,
}) => {
  return (
    <TotalsInfoCardContainer>
      <span>{icon}</span>

      <div>
        <p>{titleCard}</p>
        {isLoading ? <h1><FadeLoader/></h1> : <h1>{totalValue}</h1>}
      </div>

      <footer>
        <p>
          {/* <strong>+{percentFooter}% </strong> {textFooter} */}
        </p>
      </footer>
    </TotalsInfoCardContainer>
  );
};

export default TotalsInfoCard;
